module.exports = __webpack_public_path__ + "static/media/new-icon-cancel.b7b9bc4b.svg";